import GeniusLabsPanel from "@/components/GeniusLabsPanel";

export default function GeniusLabsPage() {
  return (
    <div className="h-screen overflow-hidden">
      <GeniusLabsPanel projectId="__global__" />
    </div>
  );
}
